module.exports = __webpack_public_path__ + "img/freistil.a662428f.jpeg";